<script setup lang="ts">
  import { computed } from 'vue';
  import type { PropType } from 'vue';
  import type { ServiceUseCaseItem } from '~/models/service';

  const props = defineProps({
    useCaseItem: {
      type: Object as PropType<ServiceUseCaseItem>,
      required: true
    },
    localePath: {
      type: Function as PropType<(to: { name: string; params: { slug: string } }) => string>,
      required: true
    }
  });

  const bgImageStyle = computed(() => {
    if (!props.useCaseItem.cover || !props.useCaseItem.cover.src) {
      return {};
    }

    return {
      '--bg-image': `url(${props.useCaseItem.cover.src})`
    };
  });
</script>

<template>
  <NuxtLink
    class="service-card-base service-list-card"
    :to="localePath({ name: 'use-cases-slug', params: { slug: useCaseItem.slug } })">
    <div class="service-list-card__icon">
      <nuxt-icon
        v-if="useCaseItem.icon"
        :name="`telekom:${useCaseItem.icon}`" />
    </div>
    <div class="service-list-card__info">
      <h2 class="service-list-card__title">{{ useCaseItem.title }}</h2>
      <p class="service-list-card__description">{{ useCaseItem.description }}</p>
    </div>
    <div
      class="service-list-card__image"
      :style="bgImageStyle" />
  </NuxtLink>
</template>
